var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal-overlay",
      on: {
        click: function ($event) {
          if ($event.target !== $event.currentTarget) return null
          return _vm.close.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "modal-content" }, [
        _c("button", { staticClass: "modal-close", on: { click: _vm.close } }, [
          _vm._v("×"),
        ]),
        _c("h2", [_vm._v("🚀 " + _vm._s(_vm.$t("UpgradetoPrime")))]),
        _c("p", { staticClass: "modal-desc" }, [
          _vm._v(" " + _vm._s(_vm.$t("Unlockboth")) + " "),
        ]),
        _c("div", { staticClass: "modal-actions" }, [
          _c(
            "button",
            { staticClass: "modal-upgrade", on: { click: _vm.upgrade } },
            [_vm._v(" " + _vm._s(_vm.$t("UpgradetoPrime99")) + " ")]
          ),
          _c(
            "button",
            { staticClass: "modal-cancel", on: { click: _vm.close } },
            [_vm._v(" " + _vm._s(_vm.$t("CancelKeep")) + " ")]
          ),
        ]),
        _c("div", { staticClass: "modal-tip" }, [
          _c("span", [_vm._v("💡 " + _vm._s(_vm.$t("ThePrimeversion")))]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }